import Vue from 'vue'
import {
    filter as _filter,
    orderBy as _orderBy,
} from 'lodash'
import * as uuid from 'uuid'

import momentService from '@/services/moment'

// ---------------------------------------------------------------------------------------------------------------------

const state = {
    notifications: {},
}

const getters = {
    getLowNotifications: state => {
        const notifications = _filter(state.notifications, { priority: 'low' })

        return _orderBy(notifications, ['createdAt'], ['asc'])
    },
}

const mutations = {
    setNotification(state, notification) {
        Vue.set(state.notifications, notification.id, notification)
    },
}

const actions = {
    push({ commit }, payload) {
        const id = uuid.v4()
        const priority = 'low'
        const text = payload.text || null
        const color = payload.color || null
        const action = payload.action || null
        const createdAt = momentService.unix()

        if (text) {
            commit('setNotification', {
                id,
                priority,
                text,
                color,
                action,
                createdAt,
            })
        }
    },

    delete({ commit }, notificationId) {
        Vue.delete(state.notifications, notificationId)
    },
}

// ---------------------------------------------------------------------------------------------------------------------

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
